export enum PageType {

  New,

  Edit,

  Detail

}
